import { render } from "./StartVirtualMachine.vue?vue&type=template&id=4718d3ac&scoped=true"
import script from "./StartVirtualMachine.vue?vue&type=script&lang=js"
export * from "./StartVirtualMachine.vue?vue&type=script&lang=js"

import "./StartVirtualMachine.vue?vue&type=style&index=0&id=4718d3ac&scoped=true&lang=less"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4718d3ac"]])

export default __exports__